<template>
  <div style="min-height:70vh;padding:20px">
    <Form :model="searchData" inline @submit.native.prevent="getData(1)" :label-width="100">
      <FormItem label="名称">
        <Input v-model="searchData.name" clearable />
      </FormItem>
      <Button type="primary" icon="ios-search" html-type="submit">搜索</Button>
    </Form>
    <Table :columns="tableColumns" :data="tableData.data" :loading="tableLoading" border style="margin:10px 0;">
      <template slot-scope="{ row }" slot="pay_type">
        <p v-if="row.pay_type == 1">充值积分优先</p>
        <p v-else-if="row.pay_type == 2">赠送积分优先</p>
        <p v-else-if="row.pay_type == 3">仅限充值积分</p>
        <p v-else-if="row.pay_type == 4">仅限赠送积分</p>
        <p v-else></p>
      </template>
      <template slot-scope="{ row }" slot="index">
        {{ (tableData.current_page - 1) * 10 + row._index + 1 }}
      </template>
      <template slot-scope="{ row }" slot="content">
        <a v-if="row.content" @click="looks(row.content)">查看</a>
      </template>
      <template slot-scope="{ row }" slot="action">
        <!-- <Poptip
          v-auth="'admin/delete'"
          transfer
          confirm
          title="您确定要购买该商品吗？"
          @on-ok="buys(row.id)"
        > -->
        <Button type="info" @click="buys(row.id)" size="small">购买</Button>
        <!-- </Poptip> -->
      </template>
    </Table>
    <Page style="text-align:right" :total="tableData.total" :page-size="tableData.per_page"
      :current="tableData.current_page" show-total @on-change="getData" />
    <Modal v-model="buyvisible" title="购买" @on-cancel="buyvisible = false" @on-ok="buysok()">
      <Form :model="buyObJ" :label-width="110">
        <FormItem label="购买数量">
          <Input type="number" v-model="buyObJ.count" />
        </FormItem>
        <FormItem label="收货地址">
          <Input v-model="buyObJ.address" />
        </FormItem>
      </Form>
    </Modal>
    <Modal title="查看内容" v-model="visible">
      <div v-html="contents" style="width: 100%;max-height:60vh;overflow:auto" />
      <div slot="footer">
        <Button type="text" size="small" @click="visible = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import indexPage from "../../mixins/indexPage";
  export default {
    data() {
      return {
        searchData: {
        },
        contents: '',
        visible: false,
        buyvisible: false,
        buyObJ: {
          count: 1,
        },
        tableColumns: [
          { title: "序号", slot: "index", width: 80, align: "center" },
          { title: "商品名称", key: "name", align: "center", minWidth: 120, },
          { title: "原价", key: "cost_price", align: "center", minWidth: 120, },
          { title: "现价", key: "price", align: "center", minWidth: 120, },
          { title: "积分使用优先顺序", slot: "pay_type", align: "center", minWidth: 120, },
          { title: "内容", slot: "content", align: "center", minWidth: 120, },
          { title: "操作", slot: "action", align: "center", minWidth: 120, },
        ],
        indexUrl: "/app/product/index",
      };
    },
    mixins: [indexPage],
    methods: {
      looks(con) {
        this.visible = true
        this.contents = con
      },
      buys(id) {
        this.buyvisible = true
        this.buyObJ.id = id
      },

      buysok() {
        this.$axios
          .post("/app/product/buy", this.buyObJ)
          .then((res) => {
            if (res.code == 1) {
              this.$Message.success('购买成功')
              this.buyObJ = {}
              this.buyvisible = false
              this.getData(this.tableData.current_page)
            } else {
              this.$Message.error(res.msg);
            }
          });
      }
    }
  };
</script>
<style scoped>
  .group-name:nth-child(n + 2)::before {
    content: " / ";
  }
</style>
